module.exports = __webpack_public_path__ + "img/12.50c35b3f.png";